<template>
  <div class="group-users">
    <SidebarLayout2 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :hasIcon="true"
            :link="'/grupos-de-usuarios/criar'"
            element="router-link"
            class="page-actions--button"
          >
            Cadastrar novo grupo
          </Button>
          <!-- EDITAR GRUPO DE USUÁRIOS -->
          <Button
            :disabled="selectedGroups.length != 1"
            :link="
              `/grupos-de-usuarios/editar/${
                selectedGroups[0] ? selectedGroups[0].codigo : null
              }`
            "
            element="router-link"
            class="page-actions--button"
          >
            Editar
          </Button>
          <!-- EXCLUIR -->
          <Button
            :disabled="selectedGroups.length == 0"
            variation="error"
            class="page-actions--button"
            @click="showAlertModal = true"
          >
            Excluir
          </Button>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <SearchInput
          v-model="searchTerm"
          class="search-term"
          @input="searchData"
        />
        <DataTable
          :cols="gridColumns"
          :rows="gridData"
          :selectableRow="true"
          :isLoading="isLoadingTableContent"
          :colsMinWidths="colsWidths"
          class="datatable"
          ref="datatable"
          notFoundMessage="Não há grupos de usuários com a busca."
          @getSelectedRows="manageSelectedGroups"
        >
          <template v-slot:editar="slotProps">
            <router-link
              class="links links--edit"
              :to="`/grupos-de-usuarios/editar/${slotProps.rowDataObj.codigo}`"
            >
              Editar
            </router-link>
          </template>
          <template v-slot:excluir="slotProps">
            <span
              class="links links--delete"
              @click.stop.prevent="
                inativeGroupUser(slotProps.rowDataObj.codigo)
              "
            >
              Excluir
            </span>
          </template>
        </DataTable>
      </template>
    </SidebarLayout2>

    <AlertModal
      v-model="showAlertModal"
      title="Excluir grupo de usuários"
      @alert-modal-confirm="inativeGroupUsers"
      @alert-modal-cancel="cancelInativeGroupUsers"
    >
      <template #text>
        Ao excluir um grupo, os usuários que pertencem <br />
        somente a este grupo ficarão sem acesso. <br />
        Você tem certeza que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'

export default {
  name: 'GroupUsers',
  components: {
    SidebarLayout2,
    SearchInput,
    DataTable,
    SidebarBlock,
    Heading,
    Button,
    AlertModal
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Grupos de usuários',
          url: '/grupos-de-usuarios',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      pageTitle: 'Grupos de usuários',
      searchTerm: null,
      /** colunas da tabela */
      gridColumns: [
        { name: 'nome', alias: 'Nome' },
        { name: 'quantidadeUsuarios', alias: 'Quantidade de Usuários' },
        { name: 'editar', alias: 'Ações' },
        { name: 'excluir' }
      ],
      /** linhas da tabela */
      gridData: [],
      /** Larguras das colunas */
      colsWidths: {
        nome: '300px',
        quantidadeUsuarios: '170px',
        ativo: '110px',
        editar: '71px',
        excluir: '71px'
      },
      /** grupos de usuarios */
      groupUsers: [],
      isLoadingTableContent: true,
      /** Grupos de usuários selecionados */
      selectedGroups: [],
      /** Código do grupo de usuário selecionado */
      selectedGroup: null,
      /** Mostrar modais */
      showAlertModal: false
    }
  },
  created() {
    this.getGroupsUsers()
  },
  methods: {
    getGroupsUsers() {
      this.$user
        .getUsersGroups()
        .then((response) => {
          /** Remover itens excluídos e ordenar pelo nome */
          let data = response.data.sort((a, b) =>
            a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
          )
          /** Formatar dados para a tabela */
          data = data.map((item) => {
            const obj = {
              data: item
            }
            return obj
          })
          this.groupUsers = data
          this.gridData = data
          this.isLoadingTableContent = false
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao apresentar a listagem de grupos.'
          })
        })
    },
    /** Selecionar os grupos de usuarios */
    manageSelectedGroups(values) {
      this.selectedGroups = values
    },
    /** Pesquisa dos grupos de usuarios */
    searchData() {
      const term = this.searchTerm
      this.gridData = this.groupUsers.filter(function(item) {
        const name = item.data.nome.toLowerCase()
        return name.includes(term.toLowerCase()) ? true : false
      })
    },
    /** Inativar grupos de usuario (botão da tabela) */
    inativeGroupUser(id) {
      this.selectedGroup = id
      this.showAlertModal = true
    },
    /** Inativar grupos de usuarios */
    inativeGroupUsers() {
      let grupos = []
      if (this.selectedGroup === null) {
        grupos = this.selectedGroups.map((a) => a.codigo)
      } else {
        grupos = [this.selectedGroup]
      }
      this.$user
        .inativeGroupUsers(grupos)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo(s) excluído(s) com sucesso.'
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir o(s) grupo(s).'
          })
        })
        .finally(() => {
          /** Resetar tabela */
          this.resetGroupUsers()
        })
    },
    /** Cancelar inativação dos grupos de usuarios */
    cancelInativeGroupUsers() {
      this.showAlertModal = false
      this.selectedGroup = null
    },
    resetGroupUsers() {
      this.showAlertModal = false
      this.selectedGroup = null
      this.selectedGroups = []
      this.getGroupsUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.search-term {
  max-width: 215px;
  margin-bottom: 40px;
}

.datatable {
  max-height: initial;
  a {
    cursor: pointer;
  }
  ::v-deep {
    .pmw-td span {
      font-size: font-size('size-small');
    }
    .no-gutters > .pmw-col {
      padding-left: 13px;
      padding-right: 13px;
    }

    /** Largura das colunas das quantidades de usuários */
    .pmw-col.pmw-th:nth-child(3),
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 170px;
    }
    /** Largura das colunas das ações */
    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-td:nth-child(4),
    .pmw-col.pmw-th:nth-child(5),
    .pmw-col.pmw-td:nth-child(5) {
      max-width: 71px;
    }

    .pmw-col.pmw-th:nth-child(4) {
      border-right: none;
    }
    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-th:nth-child(5) {
      pointer-events: none;
      .pmw-icon {
        display: none;
      }
    }
    .links {
      font-size: font-size('size-small');
      font-weight: 500;
      cursor: pointer;
      &--edit {
        color: #466af0;
      }
      &--delete {
        color: #e0414b;
      }
    }
  }
}

.group-users {
  .info-panel {
    &--main-text {
      width: 100%;
      margin-bottom: 10px;
      line-height: 1;
      font-size: font-size('size-xx-large');
      font-weight: font-weight('weight-medium');

      &__smaller {
        font-size: font-size('size-large');
      }
    }

    &--aux-text {
      margin-bottom: 10px;
      font-size: font-size('size-large');
      font-weight: font-weight('weight-light');
    }
  }

  .page-actions {
    &--button {
      width: 100%;
      cursor: pointer;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }
}
</style>
